import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/reports';

export async function query(): Promise<Record<string, any>[]> {
	const response: Response = await BBApi.get(rootUrl);
	const reports: Record<string, any>[] = await response.json();
	return reports;
}

export async function get(id: number): Promise<Record<string, any>> {
	throw new Error('Not implemented');
}

export async function create(report: Record<string, any>): Promise<Record<string, any>> {
	throw new Error('Not implemented');
}

export async function approve(id: number): Promise<void> {
	await BBApi.put(rootUrl + `/${id}`, { checked: true });
}

export async function remove(id: number): Promise<void> {
	throw new Error('Not implemented');
}
